(function () {
	angular
		.module('trackeye')
		.controller('MainController', MainController);

	MainController.$inject = [
	"AuthService",
	"ModalService",
	"AccountService",
	"LanguageService",
	"MigrationService",
	"DeviceService",
	"NotificationService",
	"AppFactory",
	"LogService",
	"$state",
	"$rootScope",
	"$localStorage",
	"CacheFactory",
	"C4ApiService"];

	function MainController(AuthService,
		ModalService,
		AccountService,
		LanguageService,
		MigrationService,
		DeviceService,
		NotificationService,
		AppFactory,
		Log,
		$state,
		$rootScope,
		$localStorage,
		CacheFactory,
		api)
	{

		window.addEventListener('error', Log.handle('Generic'));
		validateCaches();

		var vm = this;

		vm.date = new Date();
		vm.app = AppFactory;

		vm.loginForm = {};
		vm.ticketForm = {};
		vm.resetForm = {};
		vm.migrateForm = {};
		vm.accountForm = {};

		var forgotPasswordModal = ModalService.create('forgot-password', vm),
			insecureAccountModal = ModalService.create('insecure-account', vm.app),
			termsModal = ModalService.create('accept-terms'),
			newAccountModal = ModalService.create('new-account', vm),
			accountCreatedModal = ModalService.create('account-created', vm.app);

		vm.appSenders = vm.app.appSenders
		vm.mailToSupport = vm.app.mailToSupport

		vm.openForgotPasswordModal = function () {
			forgotPasswordModal.open();
		};

		vm.openNewAccountModal = function () {
			newAccountModal.open();
		};

		vm.openAccountCreatedModal = function () {
			accountCreatedModal.open();
		}

		vm.getOpenHours = function(type) {
			var open = new Date(),
				close = new Date();

			if (type == 'week') {
				open.setUTCHours(6);
				open.setUTCMinutes(0);
				close.setUTCHours(14);
				close.setUTCMinutes(0);
			} else if (type == 'fri') {
				open.setUTCHours(6);
				open.setUTCMinutes(0);
				close.setUTCHours(13);
				close.setUTCMinutes(30);
			} else {
				return 'n/a';
			}

			var open_str = moment(open).format('HH:mm'),
				close_str = moment(close).format('HH:mm');

			return open_str+' - '+close_str;
		}

		vm.migrationDefaults = {
			username: $state.params.username,
			use_old_password: false
		};

		if ($localStorage.session) {
			isWorking();
			AuthService.authenticateByRefresh($localStorage.session).then(function () {
				$state.go('dashboard.main.pages', {page: 'positions'});
			}, function () {
				delete $localStorage.session;
				AuthService.checkImpersonate();
			}).finally(isNotWorking);
		} else {
			$rootScope.$on('$viewContentLoaded', function () {
				AuthService.checkImpersonate();

				if ($state.is('main.locale')) {
					vm.switchLocale($state.params.locale_code);
				}
				if ($state.is('main.remote_auth')) {
					AuthService.remoteAuth($state.params.tokenBase64);
				}
			});
		}

		LanguageService.setDefaultLanguage();

		if ($state.params.token) {
			AuthService.setAccessToken($state.params.token);
		}

		/**
		 * Requires a username to be set, otherwise go back.
		 */
		if ($state.params.modal == 'migrate-account' && !$state.params.username) {
			$state.go('^');
		}

		vm.getLogo = function (size) {
			var path = "assets/images/" + vm.app.simpleName + "/";

			return path + vm.app.logo[size];
		};

		/**
		 *
		 * @param {object} auth
		 * @returns void
		 */
		vm.login = function (auth) {
			vm.loginForm.$setValidity('credentials', true);
			vm.loginForm.$setValidity('migrate', true);

			if (vm.loginForm.$invalid)
				return;

			isWorking();

			AuthService.authenticate(auth).then(function () {
				$state.go('dashboard.main.pages', {page: 'positions'});
				isNotWorking();
			}, function (xhr) {
				if (xhr.Conflict()) {
					var status = xhr.getResponseData('status');
					if (status === 'insecure') {
						insecureAccountModal.open();
						isNotWorking();
						return;
					} else if (status === 'terms_not_accepted') {
						var terms_array = xhr.getResponseData('data'),
							terms = terms_array.pop();

						terms.username = auth.username;
						terms.text = terms.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
						termsModal.open({
							acceptTerms: acceptTerms,
							dontAcceptTerms: dontAcceptTerms,
							terms: terms,
							token: xhr.getResponseData('token')
						});
						isNotWorking();
						return;
					}
				} else if (xhr.Unautorized()) {
					vm.loginForm.$setValidity('credentials', false);
					isNotWorking();
					Log.handle('Authenticate')(xhr, false);
					return;
				} else {
					NotificationService.danger("STR_ERROR_NOTICE_SERVER");
					isNotWorking();
					return;
				}

				// Check if app has migration support
				// if (!AppFactory.hasMigration()) {
				// 	vm.loginForm.$setValidity('credentials', false);
				// 	isNotWorking();
				// 	Log.handle('Authenticate')(xhr, false);
				// 	return;
				// }

				// // Check if the account is eligible for migration
				// MigrationService.check(auth.username, auth.password).then(function () {
				// 	$state.go('main.modal', {
				// 		modal: 'migrate-account',
				// 		username: auth.username
				// 	});
				// }, function (migrateResp) {
				// 	//Log.handle('Migrate')(migrateResp);
				// 	Log.handle('Authenticate')(xhr);
				// 	vm.loginForm.$setValidity('credentials', false);
				// }).finally(isNotWorking);
			});
		};

		// @todo move to maincontroller
		vm.resetPassword = function (email) {
			vm.resetForm.$setValidity('invalidAccount', true);

			if (!vm.resetForm.$valid)
				return;

			vm.is_loading = true;

			AuthService.requestReset(email).then(function () {
				forgotPasswordModal.close();
				NotificationService.info("STR_NOTICE_RESET_MAIL_SENT");
			}, function () {
				vm.resetForm.$setValidity('invalidAccount', false);
			}).finally(function () {
				isNotWorking();
			});
		};

		vm.createAccount = function (data) {
			vm.accountForm.device_number.$setValidity('invalidDevice', true);
			vm.accountForm.$setValidity('exists_old_platform', true);
			vm.accountForm.$setValidity('user_already_exists', true);

			if (vm.accountForm.$invalid)
				return;

			isWorking();

			DeviceService.verifyDevice(data.device_number, data.device_code).then(function () {
				AccountService.create(data).then(function (resp) {
					newAccountModal.close()
					accountCreatedModal.open()
					isNotWorking()
				}, function (xhr) {
					if (xhr.Conflict()) {
						vm.accountForm.$setValidity('user_already_exists', false);
					} else {
						NotificationService.danger("STR_ERROR_NOTICE_SERVER");
					}
				}).finally(isNotWorking);
			}, function () {
				isNotWorking();
				vm.accountForm.device_number.$setValidity('invalidDevice', false);
			});

			// MigrationService.check(data.username, data.password).then(function () {
			// 	vm.accountForm.$setValidity('exists_old_platform', false);
			// 	isNotWorking();
			// }, function () {
			// 	// DeviceService.verifyDevice...
			// })
		};

		vm.migrate = function (data) {
			vm.migrateForm.$setValidity('migrationCheck', true);
			if (vm.migrateForm.$valid) {
				UserService.migrateAccount(data).then(function () {
					$state.go('^');
					NotificationService.success('STR_NOTICE_ACCOUNT_WAS_MIGRATED');
				}, function (response) {
					if (response.status === 401) {
						vm.migrateForm.$setValidity('migrationCheck', false);
					}
				});
			}
		};

		vm.isFormFieldsValid = function (formName, fields, submitted) {
			var state = true,
				form = vm[formName];

			if (!form)
				return false;

			for (var i in fields) {
				if (form[fields[i]].$invalid) {
					state = false;
				}
			}

			if (submitted && !form.$submitted)
				return true;

			return state;
		};

		vm.switchLocale = function(locale) {
			LanguageService.setLanguage(locale);
			$state.go('main');
		}

		vm.submitTicket = function(ticket) {
			api.submitTicket(ticket).then(function() {
				NotificationService.info('STR_TICKET_SUBMITTED');
			});
		}

		function working(method) {
			return vm.method_working == method
		}

		function isWorking(method) {
			vm.method_working = method
			vm.is_loading = true;
		}

		function isNotWorking(method) {
			vm.method_working = method
			vm.is_loading = false;
		}

		function acceptTerms(terms, token, close) {
			
			AccountService.updateAccountTerms(terms, true).finally(function() {
				AuthService.saveToken({token: token});
				close();
				$state.go('dashboard.main.pages', {page: 'positions'});
			});
		}
		
		function dontAcceptTerms(terms, close) {
			AccountService.updateAccountTerms(terms, false).finally(function() {
				close();
			});
		}
		/**
		 * Checks if the cached version is equal to the current.
		 * If not, the following caches are flushed:
		 *
		 *  modelCache
		 */
		function validateCaches() {
			var cache_version = $localStorage.version,
				app_version = AppFactory.getAppVersion();

			if (cache_version === app_version)
				return;

			$localStorage.version = app_version;

			CacheFactory.get('modelCache').removeAll();
		}
	}
})();